export default "__VITE_ASSET__cf5546b3__"